// File: frontend/src/components/clubs/ClubList.tsx
// src/components/clubs/ClubList.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import "./ClubRow.css";
import { ClubModel } from "../../models/ClubModel";
import { ClubRow } from "./ClubRow";
// Sitewide pins: badge wrapper for the admin-pinned topic row
import { PinnedTopicWrap } from "../common/PinnedTopicWrap";

interface ClubListProps {
  clubs: ClubModel[];
  selectedClubId: number | null;
  onSelectClub: (clubId: number) => void;
  // Forwarded to each ClubRow for mobile pane switching
  onMobileNavigate?: () => void;
  // ID of the admin-pinned club (null = nothing pinned)
  pinnedClubId?: number | null;
}

export const ClubList: React.FC<ClubListProps> = ({
  clubs,
  selectedClubId,
  onSelectClub,
  onMobileNavigate,
  pinnedClubId = null,
}) => {
  const { t } = useTranslation();

  if (!clubs || clubs.length === 0) {
    return (
      <div className="person-list__empty">
        <p>{t("clubs_not_found", "Kulüp bulunamadı.")}</p>
      </div>
    );
  }

  return (
    <div className="person-list">
      {clubs.map(club => (
        <PinnedTopicWrap key={club.id} pinned={club.id === pinnedClubId}>
        <ClubRow
          club={club}
          isSelected={club.id === selectedClubId}
          onSelect={() => onSelectClub(club.id)}
          onMobileNavigate={onMobileNavigate}
        />
        </PinnedTopicWrap>
      ))}
    </div>
  );
};